import { GEOFLEET_BOT_AVATAR_URL } from './constants';

type Props = {
  /** Inner content box in px (square) — image scales down to fit inside without cropping */
  size?: number;
  /** Extra classes on the outer frame */
  className?: string;
  /** Perfect circle (e.g. launcher); otherwise softly rounded square */
  circle?: boolean;
};

/**
 * Geofleet assistant avatar — favicon scaled to fit (object-contain, no crop) in a soft frame.
 */
export function GeofleetChatMark({ size = 32, className = '', circle = false }: Props) {
  const inner = Math.max(16, Math.round(size));
  const pad = 2;
  const outer = inner + pad * 2;
  const outerRound = circle ? 'rounded-full' : 'rounded-lg';
  const innerRound = circle ? 'rounded-full' : 'rounded-md';

  return (
    <span
      className={`inline-flex shrink-0 bg-gradient-to-br from-sky-50 via-white to-blue-50 p-[2px] shadow-[0_1px_2px_rgba(15,23,42,0.05),0_3px_10px_-2px_rgba(0,102,255,0.15)] ring-1 ring-white/90 ${outerRound} ${className}`}
      style={{ width: outer, height: outer }}
    >
      <span
        className={`flex h-full w-full items-center justify-center overflow-hidden bg-white ${innerRound}`}
      >
        <img
          src={GEOFLEET_BOT_AVATAR_URL}
          alt=""
          role="presentation"
          loading="lazy"
          decoding="async"
          referrerPolicy="no-referrer"
          className="h-full w-full object-contain object-center"
        />
      </span>
    </span>
  );
}
